"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fraction = exports.Price = exports.formatFallbackRiskyHack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const locale_1 = require("@kawaui/locale");
const react_1 = require("react");
const styled_1 = require("./styled");
const getOptions = (_a) => {
    var { withoutTrailingDecimals, withoutGroupingSeparators } = _a, props = __rest(_a, ["withoutTrailingDecimals", "withoutGroupingSeparators"]);
    return (Object.assign(Object.assign({}, ((withoutTrailingDecimals || props.withoutDecimals) && { minimumSignificantDigits: 1 })), ((withoutGroupingSeparators || props.withoutGroupingSeperators) && { useGrouping: false })));
};
const formatFallbackRiskyHack = (price, locale, currency) => price.toLocaleString(locale, { style: 'currency', currency });
exports.formatFallbackRiskyHack = formatFallbackRiskyHack;
const superscript = (part) => part.type === 'fraction' ? (0, jsx_runtime_1.jsx)(styled_1.Fraction, { children: part.value }, "fraction") : part.value;
const getFormattedPrice = (price, locale, currency, other, isSuperscript) => {
    // note(jose.mortola): fallback for browsers without native Intl (Safari on iOS < 10)
    if (typeof Intl === 'undefined' || !Intl.NumberFormat)
        return (0, exports.formatFallbackRiskyHack)(price, locale, currency);
    const currencyFormat = new Intl.NumberFormat(locale, Object.assign({ currency, maximumFractionDigits: 20, style: 'currency' }, getOptions(other)));
    if (!isSuperscript)
        return currencyFormat.format(price);
    // note(ferando.cervera): temporary patch for older browsers (ie11, safari12, etc...)
    if (!currencyFormat.formatToParts)
        return currencyFormat.format(price);
    return currencyFormat.formatToParts(price).map(superscript);
};
exports.Price = (0, react_1.forwardRef)((props, ref) => {
    const { locale, currency } = (0, locale_1.useLocale)();
    if (typeof props.children !== 'number')
        return null; // runtime failsafe
    const { children, isCrossOut, isSuperscript, prefix, postfix } = props, otherProps = __rest(props, ["children", "isCrossOut", "isSuperscript", "prefix", "postfix"]);
    if (!locale || !currency)
        return null;
    const formattedPrice = getFormattedPrice(children, locale, currency, otherProps, isSuperscript);
    if (!formattedPrice)
        return null;
    return ((0, jsx_runtime_1.jsxs)(styled_1.Container, Object.assign({}, otherProps, { ref, isCrossOut, isSuperscript, children: [prefix, formattedPrice, postfix] })));
});
exports.Price.displayName = 'Price';
var styled_2 = require("./styled");
Object.defineProperty(exports, "Fraction", { enumerable: true, get: function () { return styled_2.Fraction; } });
exports.default = exports.Price;
